// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1lhhF","requiredAsterisk":"Info_requiredAsterisk__3RQ2I"};